<template>
  <!--checkbox -->
  <div class="checkbox-section" @click="btnClick">
    <div :class="{'checkbox-section-active': checked, 'checkbox-section-item': true}">{{name}}</div>
  </div>
</template>

<script>
import emitter from "@/mixins/emitter"
export default {
  name: "checkbox",
  mixins: [emitter],
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
        checked: false
    }
  },
   mounted() {
    this.dispatch('checkboxGroup', 'on-checkbox-add', this)
  },
  beforeDestroy() {
    // console.log('beforeDestroy:')
    this.dispatch('checkboxGroup', 'on-checkbox-remove', this)
  },
  methods: {
    btnClick() {
        // this.checked = !this.checked
        this.dispatch('checkboxGroup', 'on-checkbox-select', this)
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-section{
    display: inline-block;
    margin: 0 8px 10px 0;
  &-item{
    text-align: center;
    min-width: 60px;
    padding: 8px 10px;
    background: #fff;
    border-radius: 266.4vw;
    color:#404040;
    border: 1px solid #ebedf0;
  }
  &-active{
    background-color: #FFECE8;
    border: 1px solid #FFECE8;
    color: #ee0a24;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/checkbox/checkbox.vue